import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCardsAsync } from "../../store/apiSlice/NcategoriesSlice";
import Card from "./Card";


const Nannycategories = () => {

  const dispatch = useDispatch();
  const data = useSelector((state) => state.rootReducer.cards.data);
  const [nannycatData, setNannycatData] = useState(null);

  useEffect(() => {
    dispatch(fetchCardsAsync());
  }, []);

  useEffect(() => {
    if (data != null) {
      setNannycatData(data.data);
    }
  }, [data]);

  return (
    <>
      <div className=" nannycategories ">
        <div className="banner_categories nannycategories_bg">
          <div className="heading_categories container">
            <h1>
              <span>Nanny</span>
            </h1>
            <h1>
              <span>Services</span>
            </h1>
          </div>
        </div>

        <div className="container sections_padding">
          {nannycatData != null ? (
            <div className="row" >
              {nannycatData && Array.isArray(nannycatData) && nannycatData.map((item) => (
                <Card
                  name={item.name}
                  image={"https://d2ikvgflmehs8o.cloudfront.net/" + item.image}
                  categoryId={item._id}
                  price={item.price}
                />
              ))}
            </div>
          ) : (
            ""
          )}

        </div>
      </div>
    </>
  );
};

export default Nannycategories;
